import React from 'react';

import colors from 'styles/theme/colors';

// Outline dollar sign in a circle — the cost tier empty-state glyph, exact SVG from Figma
// ("No Cost Tiers"). Size defaults to the 33px natural size and is overridable via width/height.
// The stroke takes its 50% alpha from the color token, so tint it with `color`, not a separate
// stroke opacity.
export default function DollarCircleIcon({
  width = 33,
  height = 33,
  color = colors.black50,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      {/* The ring, plus the two stubs of the dollar sign's vertical bar that fall outside the S. */}
      <path
        d='M16.3 31.6a15.3 15.3 0 1 0 0-30.6 15.3 15.3 0 0 0 0 30.6M16.3 21.584v2.461M16.3 8.068v2.465'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.05 11.451a2.46 2.46 0 0 0-1.9-.918h-1.972c-1.258 0-2.278 1.102-2.278 2.465 0 1.156.748 2.16 1.788 2.407l3.006.714c1.173.276 2.006 1.401 2.006 2.7 0 1.523-1.142 2.764-2.55 2.764h-1.7c-.904 0-1.7-.51-2.152-1.282'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
